import React from 'react';

import { ValueGroup } from '@candu-ai/craft/ui';
import { Flags, useFlags } from 'commons/hooks';
import {
  ComponentName,
  SectionContent,
  ComponentCssClass,
} from 'craft/containers/Toolbox/components';
import { ToolboxComponentSchema } from 'craft/types';

interface Props {
  nodeIds: string[];
  schema: ToolboxComponentSchema['NameAndType'];
}

export const NameAndType = React.memo(({ nodeIds, schema }: Props) => {
  const { [Flags.CUSTOM_CLASS_NAMES]: customClassNames } = useFlags();
  if (!schema.isVisible) {
    return null;
  }
  const { variantSelector } = schema || {};
  if (nodeIds.length !== 1 && !variantSelector) {
    return null;
  }
  const VariantSelector = variantSelector || (() => null);

  return (
    <SectionContent>
      {nodeIds.length === 1 && (
        <ValueGroup>
          <ComponentName nodeId={nodeIds[0]} />
        </ValueGroup>
      )}
      <ValueGroup>
        <VariantSelector nodeIds={nodeIds} />
      </ValueGroup>
      {customClassNames && (
        <ValueGroup>
          <ComponentCssClass nodeIds={nodeIds} />
        </ValueGroup>
      )}
    </SectionContent>
  );
});

NameAndType.displayName = 'NameAndType';
